import type { PageVariant } from './Page.types';

/** True when `Page` uses a full-viewport column layout (root + content styles apply). */
export const isViewportPageVariant = (variant: PageVariant): boolean =>
	variant === 'viewportCentered' || variant === 'viewportWithFooter';
